import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import Select from 'components/forms/Select'
import NumberField from 'components/forms/NumberField'
import Input from 'components/forms/Input'
import DtoUsageAgri from 'referencial/components/usage/dto/DtoUsageAgri'
import { Button, Card, Grid2 } from '@mui/material'

const emptyFilter = {
    searchValue: null,
    year: null,
    usage: null,
}

const FormFilterVolumes = ({
    onChange = () => { },
    usages = [],
}) => {
    const [tmpFilter, setTmpFilter] = useState(emptyFilter)

    const onReset = () => {
        onChange(emptyFilter)
        setTmpFilter(emptyFilter)
    }

    return (
        <Card sx={{ padding: 1 }}>
            <Grid2 container spacing={1}>
                <Grid2 container size={12}>
                    <Grid2 size={3}>
                        <Input
                            title={i18n.search}
                            value={tmpFilter.searchValue}
                            onChange={v => setTmpFilter({ ...tmpFilter, searchValue: v })}
                            onEnterKeyPress={() => onChange(tmpFilter)}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <NumberField
                            title={i18n.year}
                            value={tmpFilter.year}
                            onChange={v => setTmpFilter({ ...tmpFilter, year: v })}
                            min={0}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <Select
                            label={i18n.usage}
                            options={usages}
                            value={tmpFilter.usage}
                            onChange={v => setTmpFilter({ ...tmpFilter, usage: v })}
                            integerValue
                            keyValue='id'
                            keyLabel='description'
                            nullLabel='&nbsp;'
                        />
                    </Grid2>
                    <Grid2 size={3} container justifyContent='flex-end' alignItems='flex-end'>
                        <Grid2>
                            <Button variant='outlined' onClick={onReset}>
                                {i18n.reinit}
                            </Button>
                        </Grid2>
                        <Grid2>
                            <Button variant='contained' onClick={() => onChange(tmpFilter)}>
                                {i18n.search}
                            </Button>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
        </Card>
    )
}

FormFilterVolumes.propTypes = {
    onChange: PropTypes.func,
    usages: PropTypes.arrayOf(PropTypes.instanceOf(DtoUsageAgri)),
}

const mapStateToProps = store => ({
    usages: store.UsageReducer.usages,
})

export default connect(mapStateToProps)(FormFilterVolumes)